import { Input } from '@gto/ui/input'

import type { MaskedInputProps } from './date-field'
import type { DateSegmentsApi } from './use-date-segments'

/**
 * Renders a segment model that someone else owns.
 *
 * `DateRangePicker` holds both of its fields' models so it can derive the
 * validation pair rather than remember it, and clear a half-typed entry that a
 * `Date | null` prop cannot express. Standalone callers want `DateField`.
 */
export function DateFieldInput({
  segments,
  ...props
}: MaskedInputProps & { segments: DateSegmentsApi }) {
  return (
    <Input
      ref={segments.inputRef}
      {...props}
      {...segments.inputProps}
      // A caller that has its own reason to mark the field invalid — a time the
      // selected day skips, a value the form rejects — wins over the mask's own
      // verdict, which would otherwise clear it back to `undefined`.
      aria-invalid={props['aria-invalid'] ?? segments.inputProps['aria-invalid']}
    />
  )
}
